import { ReportLabel } from '@ulysses-inc/harami_api_client'
import { Space } from 'antd'
import { Text } from 'src/components/nativeCompat/Text'
import { LabelAreaResultSection } from './LabelAreaResultSection'
import { LabelResultImage } from './LabelResultImage'
import { LabelResultSampleImage } from './LabelResultSampleImage'

type Props = {
  labelResult: ReportLabel
}

export const LabelResultSection = ({ labelResult }: Props) => {
  return (
    <Space direction="vertical" size="middle" key={labelResult.labelId}>
      <Text>{labelResult.name}</Text>

      <Space direction="horizontal">
        <LabelResultImage
          url={labelResult.resultImageUrl}
          recordedAt={labelResult.resultImageRecordedAt}
        />

        <LabelResultSampleImage url={labelResult.sampleImageUrl} />
      </Space>

      <Space direction="vertical" size="small">
        <Text>解析結果</Text>
        <Space direction="vertical" size="small">
          {labelResult.reportLabelInspectionAreas.map(area => (
            <LabelAreaResultSection
              key={area.labelInspectionAreaId}
              labelAreaResult={area}
            />
          ))}
        </Space>
      </Space>
    </Space>
  )
}
